export default "__VITE_ASSET__DwnOjzvT__"